import React from 'react';
import {
  ActionPlanAction,
  ActionPlanStatus,
} from '../../enums/ActionPlanStatus';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import { ButtonContainer } from './EditActionPlan.styled';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { useTranslation } from 'react-i18next';
import { ActionButtonProps } from './interfaces/actionButton';
import { actionPlanAssignedUser } from '../../helpers/actionPlanAssignedUser';

export function ActionButton ({
  actionPlanData,
  updateActionStatus,
  event,
  root,
  parentId,
  handleCreateLinkedActionPlan,
  isViewer,
}: ActionButtonProps) {
  const { userData } = userHotelDetails();
  const { t } = useTranslation();
  const selectedUser = actionPlanAssignedUser(actionPlanData);
  const isAssignedUser: boolean = selectedUser.id === userData.user.id;
  const isOwner: boolean = actionPlanData.owner.id === userData.user.id;
  const isOpenOrRejected: boolean =
    actionPlanData.status === ActionPlanStatus.open ||
    actionPlanData.status === ActionPlanStatus.rejected;
  const isAwaitingApproval: boolean =
    actionPlanData.status === ActionPlanStatus.awaitingApproval;
  const isComplete: boolean =
    actionPlanData.status === ActionPlanStatus.complete;

  return (
    <>
      {isOpenOrRejected && isAssignedUser && (
        <ButtonContainer>
          <ButtonLarge
            title={t('COMMON.ACTION_PLAN.BUTTON.SUBMIT')}
            onClick={() => updateActionStatus(ActionPlanAction.submit)}
          />
        </ButtonContainer>
      )}

      {isOpenOrRejected && isOwner && (
        <ButtonLarge
          title={t('COMMON.ACTION_PLAN.BUTTON.SAVE')}
          onClick={() => updateActionStatus(ActionPlanAction.save)}
        />
      )}

      {isAssignedUser && isAwaitingApproval && (
        <ButtonContainer>
          <ButtonLarge
            title={t('COMMON.ACTION_PLAN.BUTTON.SUBMITTED')}
            disabled={true}
          />
        </ButtonContainer>
      )}

      {isOwner && isAwaitingApproval && (
        <>
          <ButtonContainer>
            <ButtonLarge
              title={t('COMMON.ACTION_PLAN.BUTTON.APPROVE')}
              onClick={() => updateActionStatus(ActionPlanAction.accept)}
            />
          </ButtonContainer>
          <ButtonLarge
            title={t('COMMON.ACTION_PLAN.BUTTON.REJECT')}
            onClick={() => updateActionStatus(ActionPlanAction.reject)}
          />
        </>
      )}

      {isComplete && (
        <ButtonLarge
          title={t('COMMON.ACTION_PLAN.BUTTON.APPROVED')}
          disabled={true}
        />
      )}
      {!isComplete &&
        event !== 'sent' &&
        root === 'from-individual' &&
        parentId === null && (
          <ButtonLarge
            title={t('COMMON.ACTION_PLAN.BUTTON.CREATE_LINKED_ACTION_PLAN')}
            onClick={handleCreateLinkedActionPlan}
            disabled={isAwaitingApproval || isViewer}
            inverted={true}
            outlined={true}
          />
        )}
    </>
  );
}
